import { EFormFieldInputTypes } from "app/Components/Form/FormField.component";
import { RestMethod } from "app/_helpers/ApiConfig/RestMethod";
import { encodeQueryObject } from "app/_helpers/helper";
import { isArray } from "lodash";

async function getEmailServerSide(filter) {
  try {
    const response = await RestMethod.GET(
      "/global-configuration/ehs-module/get-all-email-server-side?" + (filter || "")
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getAlertsServerSide(filter) {
  try {
    const response = await RestMethod.GET(
      "/global-configuration/ehs-module/get-all-alerts-server-side?" + (filter || "")
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export const emailApis = {
  getAll: {
    api: async (filter) => {
      const response = await getEmailServerSide(encodeQueryObject(filter));

      return {
        data: response?.data?.emails || [],
        total: response?.data?.total || 0,
      };
    },
  },
};

export const alertApis = {
  getAll: {
    api: async (filter) => {
      const response = await getAlertsServerSide(encodeQueryObject(filter));

      return {
        data: response?.data?.alerts || [],
        total: response?.data?.total || 0,
      };
    },
  },
};

export const systemNotificationFilterFieldsEmail = [
  // {
  //   name: "eventType",
  //   title: "Event Type",
  //   inputType: EFormFieldInputTypes.searchableSelect,
  // },

  {
    name: "dateRange",
    title: "Date Range",
    inputType: EFormFieldInputTypes.dateRange,
  },

  {
    name: "sent",
    title: "Sent Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
  },
  {
    name: "type",
    title: "Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Notification", value: "notification" },
      { label: "Alert", value: "alert" },
    ],
  },
  {
    name: "eventType",
    title: "Event",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "this will be set By api", value: "type1" },
      { label: "this will be set By api", value: "type2" },
    ],
  },

  //dateDiffrence users.ehsSite
];
export const systemNotificationFilterFieldsAlert = [
  {
    name: "userName",
    title: "User Name",
    inputType: EFormFieldInputTypes.text,
  },
  {
    name: "dateRange",
    title: "Date Range",
    inputType: EFormFieldInputTypes.dateRange,
  },
  {
    name: "readStatus",
    title: "Read Status",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Yes", value: "yes" },
      { label: "No", value: "no" },
    ],
  },
  {
    name: "type", // prev
    title: "Type",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "Notification", value: "notification" },
      { label: "Alert", value: "alert" },
    ],
  },
  {
    name: "eventType", // prev
    title: "Event",
    inputType: EFormFieldInputTypes.searchableSelect,
    options: [
      { label: "this will be set By api", value: "type1" },
      { label: "this will be set By api", value: "type2" },
    ],
  },
];
